import { Plus, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const PayLinesEditor = ({ title, lines, onChange, quick = [], testPrefix, tone }) => {
  const update = (i, patch) => onChange(lines.map((l, idx) => (idx === i ? { ...l, ...patch } : l)));
  const add = (label = "", amount = "") => onChange([...lines, { label, amount: amount === "" ? "" : String(amount) }]);
  return (
    <div className="space-y-2 rounded-lg border p-3" data-testid={`${testPrefix}-editor`}>
      <Label className={`text-xs font-semibold uppercase tracking-wide ${tone}`}>{title}</Label>
      <div className="flex flex-wrap gap-1">
        {quick.map((q) => (
          <Button key={q.label} type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => add(q.label, q.compute ? q.compute() : "")} data-testid={`${testPrefix}-quick-${q.id}`}>
            <Plus className="w-3 h-3 mr-1" />{q.label}
          </Button>
        ))}
      </div>
      {lines.map((l, i) => (
        <div key={i} className="grid grid-cols-[1fr_120px_32px] gap-2 items-center" data-testid={`${testPrefix}-line-${i}`}>
          <Input value={l.label} placeholder="Descrição" onChange={(e) => update(i, { label: e.target.value })} data-testid={`${testPrefix}-label-${i}`} />
          <Input type="number" step="0.01" min="0" value={l.amount} placeholder="0.00" onChange={(e) => update(i, { amount: e.target.value })} data-testid={`${testPrefix}-amount-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-8 w-8 text-destructive" onClick={() => onChange(lines.filter((_, idx) => idx !== i))} data-testid={`${testPrefix}-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
        </div>
      ))}
      {lines.length === 0 && <p className="text-xs text-muted-foreground">Nenhuma linha — use os botões acima ou adicione manualmente.</p>}
      <Button type="button" size="sm" variant="ghost" className="h-7 text-xs" onClick={() => add()} data-testid={`${testPrefix}-add-custom`}><Plus className="w-3 h-3 mr-1" /> Linha personalizada</Button>
    </div>
  );
};
